<template>
    <oButton :class="['opteo-sidebar-menu-link alerts-sidebar-menu', { active }]" color="white">
        <svg
            width="30"
            height="32"
            viewBox="0 0 30 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 29.722a4.16 4.16 0 0 0 6 0M25 15v-4.1A10.21 10.21 0 0 0 15 1 10.3 10.3 0 0 0 5 11v4c0 4.5-3.6 5.3-3.6 7.8 0 2.3 5.3 4.1 13.6 4.1s13.6-1.8 13.6-4.1c0-2.5-3.6-3.3-3.6-7.8Z"
                stroke="#CCCCCE"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="square"
            />
        </svg>
        <AlertsCounter class="alerts-counter" />
    </oButton>
</template>

<script lang="ts" setup>
import { oButton } from '@opteo/components-next'
import AlertsCounter from '@/components/User/Sidebars/AlertsSidebar/AlertsCounter.vue'

defineProps<{
    active: boolean
}>()
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@import '@/assets/css/theme.scss';

.alerts-sidebar-menu svg path {
    stroke: #ccccce;
    transition: all 0.25s cubic-bezier(0.19, 1, 0.22, 1);
}
.alerts-sidebar-menu.active svg path {
    stroke: $opteo-blue;
}

.alerts-counter {
    position: absolute;
    top: 0.625rem;
    left: 1.875rem;
}

.notification-fade-enter-active {
    transition:
        transform 0.75s cubic-bezier(0.68, -0.6, 0.32, 1.6),
        opacity 0.75s cubic-bezier(0.68, -0.6, 0.32, 1.6);
}
.notification-fade-leave-active {
    transition:
        transform 0.75s cubic-bezier(0.68, -0.6, 0.32, 1.6),
        opacity 0.75s cubic-bezier(0.68, -0.6, 0.32, 1.6);
}
.notification-fade-enter-from,
.notification-fade-leave-to {
    transform: scale(20%);
    opacity: 0;
}
</style>
